/* eslint-disable no-param-reassign */
import { createSlice, createAction } from '@reduxjs/toolkit';

import initialState from '../../../domain/app/entities/validarDesafioCP';


// ---------------- Saga's response ----------------
function fetchValidarDesafioCPSuccess(state, action) {
  const { respuestaServicio } = action.payload;
  state.response = respuestaServicio;
  state.errorFetchConfirmar = false;
}

function fetchValidarDesafioCPError(state) {
  state.response = [];
  state.errorFetchConfirmar = true;
}


const fetchValidarDesafioCP = createAction('fetchValidarDesafioCP');

// ------------- connection ------------- //

const validarDesafioCPReducer = createSlice({
  name: 'ValidarDesafioCP',
  initialState,
  reducers: {
    fetchValidarDesafioCPSuccess,
    fetchValidarDesafioCPError,
  },
});

export const validarDesafioCPAction = {
  ...validarDesafioCPReducer.actions,
  fetchValidarDesafioCP,
};

export default validarDesafioCPReducer.reducer;